<template>
  <NavBar />
  <div class="container-fluid page-body-wrapper">
    <MenuBar />
    <div class="main-panel">
      <div class="content-wrapper">
        <div class="page-header">
          <h3 class="page-title">
            <span class="page-title-icon bg-gradient-primary text-white me-2">
              <i class="mdi mdi-home"></i>
            </span>
            Dashboard
          </h3>
        </div>
        <div
          class="row"
          v-if="
            (release_notes != null && release_notes.length > 0) ||
            (user_list != null && user_list.length > 0)
          "
        >
          <nav>
            <div class="nav nav-tabs mb-3" id="nav-tab" role="tablist">
              <button
                class="nav-link active"
                id="nav-contact-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-contact"
                type="button"
                role="tab"
                aria-controls="nav-contact"
                aria-selected="false"
                style="color: #2b3889"
              >
                Released Products
              </button>
              <button
                class="nav-link"
                id="nav-home-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-home"
                type="button"
                role="tab"
                aria-controls="nav-home"
                aria-selected="true"
                style="color: #2b3889"
                v-if="user_list != null && user_list.length > 0"
              >
                Users
              </button>
            </div>
          </nav>
          <div class="tab-content" id="nav-tabContent">
            <div
              class="tab-pane fade active show"
              id="nav-contact"
              role="tabpanel"
              aria-labelledby="nav-contact-tab"
            >
              <div class="col-12">
                <div class="card">
                  <div class="card-body">
                    <!-- <RelasedProductList :releasedProductList="lstProductReleases"
                                    v-on:selected-data="getSelectedData"></RelasedProductList> -->
                    <DataTable
                      class="table-responsive"
                      v-model:filters="filters"
                      :value="release_notes"
                      stripedRows
                      scrollable
                      scrollHeight="400px"
                      tableStyle="min-width: 50rem"
                    >
                      <template #empty> No data found. </template>

                      <Column header="Sr. no" headerStyle="width:3rem">
                        <template #body="slotProps">
                          {{ slotProps.index + 1 }}
                        </template>
                      </Column>

                      <Column
                        v-for="col of release_note_columns"
                        :key="col.field"
                        :field="col.field"
                        :header="col.header"
                        sortable
                      ></Column>
                      <Column
                        field="prn_created_by"
                        header="Latest Version Released By"
                        sortable
                      >
                        <template #body="slotProps">
                          <!-- <p >
            {{ slotProps.data.prn_created_by }}
          </p> -->
                          <p
                            class="user-info-label"
                            @click="
                              displayUserDetail(
                                $event,
                                slotProps.data.prn_created_by,
                              )
                            "
                            severity="secondary"
                            rounded
                          >
                            {{ slotProps.data.prn_created_by_user }}
                          </p>
                        </template>
                      </Column>
                      <Column
                        field="prn_release_date"
                        header="Last Release Date"
                        sortable
                      >
                        <template #body="slotProps">
                          {{ formatDateTime(slotProps.data.prn_release_date) }}
                        </template>
                      </Column>

                      <Column
                        header="Actions"
                        style="width: 10%; min-width: 8rem"
                      >
                        <template #body="slotProps">
                          <a
                            class="btn-grid-action"
                            data-bs-toggle="Click to Download"
                            :title="'Download ' + slotProps.data.prn_file_name"
                            @click="downloadReleaseNote(slotProps.data)"
                            v-if="
                              auth_store.logged_in_user != undefined &&
                              auth_store.logged_in_user.user != null &&
                              auth_store.logged_in_user.user.usr_role != null &&
                              auth_store.logged_in_user.user.usr_role
                                .url_role_code != 'RST'
                            "
                          >
                            <i
                              class="mdi mdi-arrow-down-bold-circle-outline mdi-24px"
                            ></i>
                          </a>
                          <a
                            class="btn-grid-action"
                            data-bs-toggle="Click to View"
                          >
                            <i
                              class="mdi mdi mdi-eye mdi-24px"
                              @click="viewProductReleaseDoc(slotProps.data)"
                            ></i>
                          </a>
                        </template>
                      </Column>
                    </DataTable>
                    <div class="view-all-text float-end">
                      <RouterLink to="/released-product">
                        View All
                        <i
                          class="mdi mdi-chevron-double-right icon-sm align-middle"
                        ></i>
                      </RouterLink>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="nav-home"
              role="tabpanel"
              aria-labelledby="nav-home-tab"
              v-if="user_list != null && user_list.length > 0"
            >
              <div class="col-12 grid-margin">
                <div class="card">
                  <div class="card-body">
                    <DataTable
                      class="table-responsive"
                      v-model:filters="user_filters"
                      :value="user_list"
                      stripedRows
                      scrollable
                      scrollHeight="400px"
                      tableStyle="min-width: 50rem"
                    >
                      <template #empty> No data found. </template>
                      <Column header="Sr. no" headerStyle="width:3rem">
                        <template #body="slotProps">
                          {{ slotProps.index + 1 }}
                        </template>
                      </Column>
                      <Column
                        v-for="col of user_columns"
                        :key="col.field"
                        :field="col.field"
                        :header="col.header"
                        sortable
                      ></Column>

                      <Column
                        field="usr_created_on"
                        header="Created On"
                        sortable
                      >
                        <template #body="slotProps">
                          {{ formatDateTime(slotProps.data.usr_created_on) }}
                        </template>
                      </Column>
                      <Column field="user_status" header="Status">
                        <template #body="slotProps">
                          <span
                            :class="[
                              slotProps.data.usr_status == 0
                                ? 'badge badge-gradient-danger'
                                : 'badge badge-gradient-success',
                            ]"
                            style="font-size: 0.875rem"
                          >
                            {{
                              slotProps.data.usr_status == 1
                                ? "Active"
                                : "Deactive"
                            }}
                          </span>
                        </template>
                      </Column>

                      <!-- <Column header="Actions" style="width: 10%; min-width: 8rem">
                                                <template #body="slotProps">
                                                    <a class="btn-grid-action" title="Click to Deactive"
                                                        @click="manageActiveStatus(slotProps.data)"
                                                        v-if="slotProps.data.usr_status == 1">
                                                        <i class="mdi mdi-account-off mdi-24px"></i>
                                                    </a>
                                                    <a class="btn-grid-action" title="Click to Active"
                                                        @click="manageActiveStatus(slotProps.data)"
                                                        v-if="slotProps.data.usr_status == 0">
                                                        <i class="mdi mdi mdi-account-check mdi-24px"></i>
                                                    </a>
                                                    <a class="btn-grid-action" title="Click to Modify"
                                                        @click="editUserDetails(slotProps.data)">
                                                        <i class="mdi mdi-border-color mdi-24px"></i>
                                                    </a>
                                                    <a class="btn-grid-action" title="Click to Reset Password"
                                                        @click="btnResetPassClick(slotProps.data)">
                                                        <i class="mdi mdi mdi-lock mdi-24px"></i>
                                                    </a>
                                                </template>
                                            </Column> -->
                    </DataTable>
                    <div class="view-all-text float-end">
                      <router-link to="/user-management" class="text-primary"
                        >View All
                        <i
                          class="mdi mdi-chevron-double-right icon-sm align-middle"
                        ></i
                      ></router-link>
                      <!-- <a href="../../pages/user-list/user-list.html">
                        View All
                        <i
                          class="mdi mdi-chevron-double-right icon-sm align-middle"
                        ></i
                      ></a> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <OverlayPanel ref="op">
    <div class="flex flex-column gap-3">
      <div class="flex align-items-center gap-2">
        <img src="../../assets/images/user-icon.png" style="width: 3rem" />
        <div>
          <span class="font-medium"
            >{{ objUser.user.usr_user_name }}({{
              objUser.user.url_role_desc
            }})</span
          >
          <p class="text-sm text-color-secondary" id="userEmail">
            {{ objUser.user.usr_email }} &nbsp;<span
              ><i
                class="mdi mdi-content-copy mdi-20px"
                @click="copyToClipBoard(objUser.user.usr_email)"
                v-if="!isTextCopied"
                v-tooltip="{
                  value: 'Click to Copy',
                  showDelay: 1000,
                  hideDelay: 300,
                }"
              ></i>
              <i
                class="mdi mdi-check-all mdi-20px"
                style="color: limegreen"
                v-if="isTextCopied"
                v-tooltip="{
                  value: 'Copied',
                  showDelay: 1000,
                  hideDelay: 300,
                }"
              ></i
            ></span>
          </p>
        </div>
        <!--  -->
      </div>
      <hr style="margin: -0.5rem 0" />
      <div class="flex align-items-center gap-2">
        <a
          :href="
            'mailto:' +
            objUser.user.usr_email +
            '?subject=your title&body=The message'
          "
        >
          <img src="../../assets/images/outlook-logo.png" style="width: 3rem" />
          <p class="text-sm">Outlook</p>
        </a>
        <a
          :href="
            'https://teams.microsoft.com/l/chat/0/0?users=' +
            objUser.user.usr_email
          "
          target="_blank"
        >
          <img src="../../assets/images/teams-logo.png" style="width: 3rem" />
          <p class="text-sm">Teams</p>
        </a>
      </div>
    </div>
  </OverlayPanel>
</template>

<script setup>
/* eslint-disable */
import OverlayPanel from "primevue/overlaypanel";
import MenuBar from "@/components/shared/common/menu-bar.vue";
import NavBar from "@/components/shared/common/nav-bar.vue";
import axios from "axios";
import { ref, onBeforeMount } from "vue";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import { FilterMatchMode } from "primevue/api";
import { format } from "date-fns";
import { toast } from "vue3-toastify";
import router from "@/router";
import { useAuthStore } from "@/store/auth_store";

const auth_store = useAuthStore();
const user = ref(null);
const release_notes = ref(null);
const user_list = ref(null);
const content_type = ref("");

const op = ref();
const isTextCopied = ref(false);
const showUserInfo = ref(false);
const objUser = ref({});

const filters = {
  global: { value: null, matchMode: FilterMatchMode.CONTAINS },
};
const user_filters = {
  global: { value: null, matchMode: FilterMatchMode.CONTAINS },
};

const release_note_columns = [
  { field: "prd_name", header: "Product Name" },
  { field: "prd_product_line", header: "Product Line" },
  // { field: "prn_created_by_user", header: "Latest Version Released By" },
  { field: "prn_firmware", header: "Latest Firmware" },
  { field: "prn_version", header: "Latest Version" },
  // { field: 'prn_release_date', header: 'Last Released On' },
];

const user_columns = [
  { field: "usr_user_name", header: "User Name" },
  { field: "usr_email", header: "Email" },
  { field: "url_role_desc", header: "Role" },
  { field: "usr_created_by", header: "Created By" },
  // { field: 'usr_created_on', header: 'Created On' },
];

onBeforeMount(() => {
  user.value = auth_store.logged_in_user.user;
  if (user.value != null) {
    fetchDashboardData();
  }
});

async function fetchDashboardData() {
  await axios
    .get("/fetch_dashboard_data?usr_id=" + user.value.usr_id)
    .then((res) => {
      user_list.value =
        res.data.users != undefined && res.data.users != null
          ? res.data.users
          : null;
      release_notes.value =
        res.data.release_notes != undefined && res.data.release_notes != null
          ? res.data.release_notes
          : null;
    })
    .catch((err) => {});
}

const formatDateTime = (value) => {
  if (value != null) return format(value, "MMM dd, yyyy").toLocaleString();
  return "";
};

const downloadReleaseNote = (objselectedItem) => {
  const obj_file = {
    file_path: objselectedItem.prn_file_location,
    file_name: objselectedItem.prn_file_name,
    prd_name: objselectedItem.prd_name,
    file_type: "versions",
  };

  axios
    .post("/download_file", obj_file, { responseType: "blob" })
    .then((res) => {
      if (res.data != undefined && res.data != null) {
        const file_type = objselectedItem.prn_file_name.split(".")[1];

        if (file_type == "pdf") content_type.value = "application/pdf";
        else if (file_type == "docx")
          content_type.value =
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
        else if (file_type == "doc") content_type.value = "application/msword";
        else if (file_type == "xlsx")
          content_type.value =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        else if (file_type == "xls")
          content_type.value = "application/vnd.ms-excel";
        else content_type.value = "application/text";

        const blob = new Blob([res.data], {
          type: content_type.value,
        }); //"application/pdf" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = objselectedItem.prn_file_name;
        link.click();
      }
    })
    .catch((err) => {
      toast("File not Found.", {
        autoClose: 2000,
        theme: "colored",
        type: "error",
        position: "bottom-left",
        dangerouslyHTMLString: true,
      });
    });
};

const viewProductReleaseDoc = (objselectedItem) => {
  auth_store.selectedProduct = objselectedItem;
  router.push({ name: "view-product" });
};

const displayUserDetail = (event, usr_id) => {
  op.value.toggle(event);

  // Fetch User Details
  axios
    .get("/fetch_user_by_usr_id?usr_id=" + usr_id)
    .then((res) => {
      showUserInfo.value = true;
      objUser.value = res.data;
    })
    .catch((err) => {});
};

const copyToClipBoard = (strData) => {
  isTextCopied.value = false;
  // Copy the text inside the text field
  navigator.clipboard.writeText(strData);

  isTextCopied.value = true;
  resetStatus();
};

function resetStatus() {
  setTimeout(() => {
    isTextCopied.value = false;
  }, 5000);
}
</script>
